var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.066,
    height: 15.919,
    viewBox: "0 0 11.066 15.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "placeholder",
    d: "M-.717,0A5.54,5.54,0,0,0-6.25,5.533c0,3.835,5.539,10.385,5.539,10.385S4.816,9.179,4.816,5.533A5.539,5.539,0,0,0-.717,0ZM.953,7.153a2.354,2.354,0,0,1-1.669.69,2.353,2.353,0,0,1-1.669-.69,2.364,2.364,0,0,1,0-3.339A2.345,2.345,0,0,1-.717,3.123a2.346,2.346,0,0,1,1.669.692A2.364,2.364,0,0,1,.953,7.153Zm0,0",
    transform: "translate(6.25)",
    fill: "#ff1f6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayIcon);
export default __webpack_public_path__ + "static/media/delayIcon.dad0f05b70c70e9bc38befabf4b1135f.svg";
export { ForwardRef as ReactComponent };